
/**
 * This is a function you can call to safely serialize anything to JSON.
 * The built-in JSON.stringify() throws an exception for circular references and can't handle
 * many built-ins such as HTMLElements and the global window object.
 */
export function safeSerialize(obj: {}): string {
  let str;

  try {
    const seenObjects: {}[] = [];
    str = JSON.stringify(obj, (key: string, value: {}) => {
      if (value === window) {
        return '[window]';
      } else if (value instanceof HTMLElement) {
        return '[HTMLElement]';
      } else if (typeof value === 'function') {
        return '[function]';
      } else if (typeof value === 'object') {
        if (value === null) {
          return value;
        } else if (seenObjects.indexOf(value) === -1) {
          seenObjects.push(value);
          return value;
        } else {
          return '[circular]';
        }
      } else {
        return value;
      }

    });
  } catch (err) {
    // Note: we make this be a JSON string, so that consumers
    // can always call JSON.parse.
    str = JSON.stringify('[object]');
  }

  return str;
}
